import {logs} from '@opentelemetry/api-logs'
import {OTLPLogExporter} from '@opentelemetry/exporter-logs-otlp-http'
import {resourceFromAttributes} from '@opentelemetry/resources'
import {BatchLogRecordProcessor, LoggerProvider} from '@opentelemetry/sdk-logs'

const MAX_QUEUE_SIZE = 2048 // Máximo de logs na fila antes de começar a descartar
const MAX_BATCH_SIZE = 512 // Quantidade máxima de logs por batch enviado
const SCHEDULED_DELAY_MS = 5000 // Intervalo entre envios em ms
const EXPORT_TIMEOUT_MS = 30000 // Timeout para export em ms

function toBase64(value: string): string {
  const bytes = new TextEncoder().encode(value)
  const binary = Array.from(bytes, byte => String.fromCharCode(byte)).join('')
  return btoa(binary)
}

function buildOtelHeaders(): Record<string, string> {
  const headers: Record<string, string> = {}

  const username = import.meta.env.VITE_OTEL_BASIC_AUTH_USERNAME
  const password = import.meta.env.VITE_OTEL_BASIC_AUTH_PASSWORD

  if (username && password !== undefined) {
    headers.Authorization = `Basic ${toBase64(`${username}:${password}`)}`
  }

  const scopeOrgId =
    import.meta.env.VITE_ENVIRONMENT === 'production'
      ? import.meta.env.VITE_OTEL_SCOPE_ORG_ID
      : import.meta.env.VITE_OTEL_SCOPE_ORG_ID_STAGE

  if (scopeOrgId) {
    headers['X-Scope-OrgID'] = scopeOrgId
  }

  return headers
}

let initialized = false

export function initOtel(): void {
  if (initialized) return

  const endpoint =
    import.meta.env.VITE_ENVIRONMENT === 'production'
      ? import.meta.env.VITE_OTEL_LOGS_ENDPOINT
      : import.meta.env.VITE_OTEL_LOGS_ENDPOINT_STAGE

  const resource = resourceFromAttributes({
    'deployment.environment': import.meta.env.VITE_ENVIRONMENT || 'development',
    'service.name': 'onboarding'
  })

  const exporter = new OTLPLogExporter({
    headers: buildOtelHeaders(),
    url: endpoint
  })

  const loggerProvider = new LoggerProvider({
    processors: [
      new BatchLogRecordProcessor({
        exportTimeoutMillis: EXPORT_TIMEOUT_MS,
        exporter,
        maxExportBatchSize: MAX_BATCH_SIZE,
        maxQueueSize: MAX_QUEUE_SIZE,
        scheduledDelayMillis: SCHEDULED_DELAY_MS
      })
    ],
    resource
  })

  logs.setGlobalLoggerProvider(loggerProvider)
  initialized = true

  const flush = (): void => {
    loggerProvider.forceFlush().catch(error => {
      console.error('[OtelLogger] forceFlush error:', error)
    })
  }
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') flush()
  })
  document.addEventListener('pagehide', flush)
}
